export default __webpack_public_path__ + "static/media/leonie02.8d9a368c.png";